// Core
import React, { useEffect, useState } from "react";
//Import Scss
import "./styles.scss";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchSingleFailureAnalysisRequest } from "../../../../Redux/Slices/failureAnalysisReqSlice";

const BearingUseInformation = (farId) => {
  const [driveDetails, setDriveDetails] = useState({});
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    getIndividualData();
  }, []);

  const getIndividualData = () => {
    dispatch(
      fetchSingleFailureAnalysisRequest({
        data: {
          remote_failure_details_id: id || farId.farId,
        },
        callBack: getDriveData,
      })
    );
  };

  const getDriveData = (data) => {
    setDriveDetails(data?.result?.remote_failure_drive_details);
  };
  
  const bearingUseDetails = [
    { label: "Power", value: driveDetails?.power },
    {
      label: "Direct Drive",
      value: driveDetails?.direct_drive_name,
    },
    {
      label: "Gear Drive",
      value: driveDetails?.gear_drive_name,
    },
    { label: "Belt Drive", value: driveDetails?.belt_drive_name },
    { label: "Additional Details", value: driveDetails?.additional_details },
  ];

  return (
    <div className="DetailsContainer">
      <div className="DetailsSection">
        <h2>Drives</h2>
        {bearingUseDetails.map((item, index) => (
          <div className="DetailsRow" key={index}>
            <div className="DetailsLabel">{item.label}</div>
            <div className="DetailsValue">: {item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BearingUseInformation;
